import React from "react";
import { Button, Tag, Tooltip } from "@netapp/bxp-design-system-react";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";
import styles from "./RoleTag.module.scss";

const RoleTag = ({ name, description, onClose, closeLabel }) => (
    <Tag className={styles.tag} style={{ display: "inline-flex", alignItems: "center", padding: onClose ? "0 4px 0 12px" : "0 12px" }}>
        <span className={styles.label}>{name}</span>
        {description ? <Tooltip>{description}</Tooltip> : null}
        {onClose && (
            <Button
                variant="icon"
                className={styles.close}
                aria-label={closeLabel || name}
                onClick={(event) => {
                    event.stopPropagation();
                    onClose();
                }}
            >
                <CloseIcon />
            </Button>
        )}
    </Tag>
);

export default RoleTag;
